import { getPersistentDeviceId } from "@/lib/constants";
import { LOS_API_ENDPOINTS, RTK_TAGS } from "@/lib/constants/Api";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const creditScoreApi = createApi({
  reducerPath: "creditScore",
  tagTypes: [
    RTK_TAGS.APPLICATION_TAG,
    RTK_TAGS.CUSTOMER_TAG,
    RTK_TAGS.ADDRESS_TAG,
    RTK_TAGS.CREDIT_SCORE,
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_CREDIT_SCORE_API_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      const deviceId = getPersistentDeviceId();
      headers.set("x-device-type", `web`);
      headers.set("x-device-id", deviceId);
      headers.set("x-device-name", `${window?.navigator?.userAgent}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCustomerStatus: builder.query({
      query: () => {
        return {
          url: `v1${LOS_API_ENDPOINTS.CREDIT_SCORE_ENDPOINT().CUSTOMER_STATUS}`,
          method: "GET",
        };
      },
      providesTags: [RTK_TAGS.CREDIT_SCORE],
    }),
    getPanDetails: builder.query({
      query: () => {
        return {
          url: `v1${LOS_API_ENDPOINTS.CREDIT_SCORE_ENDPOINT().PAN_DETAILS}`,
          method: "GET",
        };
      },
      providesTags: [RTK_TAGS.CREDIT_SCORE],
    }),
    verifyPanDetails: builder.mutation({
      query: (body) => {
        return {
          url: `v1${
            LOS_API_ENDPOINTS.CREDIT_SCORE_ENDPOINT().VERIFY_PAN_STATUS
          }`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [RTK_TAGS.CREDIT_SCORE, RTK_TAGS.CUSTOMER_TAG],
    }),
    creditScoreDashboardDataLatest: builder.mutation({
      query: (body) => {
        return {
          url: `v1${
            LOS_API_ENDPOINTS.CREDIT_SCORE_ENDPOINT()
              .CREDITSCORE_DASHBOARD_LATEST
          }`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [RTK_TAGS.CREDIT_SCORE],
    }),
    creditScoreDashboardDataLatestRefresh: builder.mutation({
      query: (body) => {
        return {
          url: `v1${
            LOS_API_ENDPOINTS.CREDIT_SCORE_ENDPOINT()
              .CREDITSCORE_DASHBOARD_LATEST_REFRESH
          }`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [RTK_TAGS.CREDIT_SCORE],
    }),
    creditDashboardDataLast: builder.query({
      query: () => {
        return {
          url: `v1${
            LOS_API_ENDPOINTS.CREDIT_SCORE_ENDPOINT().CREDIT_DASHBOARD_LAST
          }`,
          method: "GET",
        };
      },
      invalidatesTags: [RTK_TAGS.CREDIT_SCORE],
    }),
  }),
});
export const {
  useGetCustomerStatusQuery,
  useGetPanDetailsQuery,
  useVerifyPanDetailsMutation,
  useCreditDashboardDataLastQuery,
  useCreditScoreDashboardDataLatestMutation,
  useCreditScoreDashboardDataLatestRefreshMutation,
} = creditScoreApi;
export { creditScoreApi };
